import useAuthUtilities from '@/AuthMiddleware/AuthUtilities';
import { productApiClient } from '@/clients/ProductAPIClient';
import { AlbumState } from '@/data/models/albumState';
import { useMutation } from '@tanstack/react-query';

export type CmsProductType = 'AudioAlbum' | 'AudioVideoAlbum' | 'MusicVideo';

export default function useReplicateProductMutation() {
  const { canUserEditProduct } = useAuthUtilities();

  return useMutation({
    mutationFn: async ({
      albumId,
      productType,
      state,
    }: {
      albumId: string | number;
      productType: CmsProductType;
      state: AlbumState;
    }) => {
      if (!canUserEditProduct(state)) {
        return;
      }

      return await productApiClient.replicateProduct(
        albumId.toString(),
        productType,
        'CMS'
      );
    },
  });
}
